import { Helpers } from "@dandelion/core";

export function buildMinorRespiratoryPeriods(model: any): Array<{ procedureStartDate: string, procedureEndDate: string }> {
    const newPeriods = [];
    const procedureList = Helpers.getObjByPath('core.proceduresTreatments.proceduresList', model);
    const ventilazionePeriods = procedureList?.filter(
        (procedure: any) => procedure.procedure == 'procTreatCodification.invVentil'
            || procedure.procedure == 'procTreatCodification.noInvVentil' ||
            procedure.procedure == 'procTreatCodification.ino'
    ).flatMap(
        (procedure: any) => procedure.procedurePeriods
    );
    const singlePeriod = procedureList?.filter(
        (procedure: any) => procedure.procedure == 'procTreatCodification.ecmo'
            || procedure.procedure == 'procTreatCodification.tracheost'
    )
    const startDate = new Date(Helpers.getObjByPath('core.administrativeInfo.icuAdmDate', model));
    const dischargeDate = new Date(Helpers.getObjByPath('core.outcome.icuDisDate', model));
    const endDate = (!dischargeDate || isNaN(dischargeDate.getTime()))
        ? new Date()
        : dischargeDate;

    if (startDate > endDate) {
        return [];
    }

    let currentDate = startDate;
    let startingPeriod: Date | null = null;
    while (currentDate <= endDate) {
        const currentDateString = currentDate.toISOString().substring(0, 10);
        const isInSomeVentilazione = ventilazionePeriods ? ventilazionePeriods.some(
            (period: any) => period && period.procedureStartDate <= currentDateString && period.procedureEndDate >= currentDateString
        ) : false;

        const isInSomeSignlePeriods = singlePeriod ? singlePeriod.some(
            (period: any) => period && period.startDateMaxOne <= currentDateString && period.endDateMaxOne >= currentDateString
        ) : false;

        if ((isInSomeVentilazione || isInSomeSignlePeriods) && startingPeriod != null) {
            const dateBefore = new Date(currentDate.getTime());
            dateBefore.setUTCDate(currentDate.getUTCDate() - 1);
            newPeriods.push({ procedureStartDate: startingPeriod.toISOString().substring(0, 10), procedureEndDate: dateBefore.toISOString().substring(0, 10) });
            startingPeriod = null;
        }

        if (!isInSomeVentilazione && !isInSomeSignlePeriods && startingPeriod == null) {
            startingPeriod = new Date(currentDate);
        }

        currentDate.setUTCDate(currentDate.getUTCDate() + 1);
    }

    if (startingPeriod != null) {
        const dateBefore = new Date(currentDate.getTime());
        dateBefore.setUTCDate(currentDate.getUTCDate() - 1);
        newPeriods.push({ procedureStartDate: startingPeriod.toISOString().substring(0, 10), procedureEndDate: dateBefore.toISOString().substring(0, 10) });
    }

    return newPeriods;
}